import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {
  error: any;

  backToHome() {
    this._router.navigate([`bade-loft/dashboard`]);
  }

  constructor(private _route: ActivatedRoute,
    private _router: Router) { }

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      this.error = params;
    });
  }

}
